export const VALIDATIONS = {
  PASSWORD_MIN_LENGTH: 8,
  LOCALES: {
    REQUIRED: 'Campo requerido',
    MIN_LENGTH: (minLength: number) => `Mínimo ${minLength} caracteres`,
    VALID_EMAIL: 'Debe ser un formato de email válido',
  },
}
